// extracted by mini-css-extract-plugin
export default {"container":"OfferSelect_container__WkZCp","header":"OfferSelect_header__xjkAv","buttonWrapper":"OfferSelect_buttonWrapper__JOTNk","button":"OfferSelect_button__nnmm1"};